<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li class="tabLi" v-for="(data, $index) in langData" :key="$index" :class="{ active: $index == 0 }">
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a :class="true ? 'tab' + $index : ''" data-toggle="tab" :href="true ? '#tab-' + $index : ''" aria-expanded="true" @click="showTab($event, $index)">{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form :model="eventGroupDetail" ref="eventGroupDetail" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div :id="'tab-' + index" v-for="(langItem, index) in eventGroupDetail.langMap" :key="index" class="tab-pane">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Group Type </label>
                <div class="col-sm-4">
                  <div>
                    <el-select v-model="eventGroupDetail.eventGroupType" disabled>
                      <el-option v-for="item in eventGroupTypeObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </div>
                </div>
                <label class="col-sm-2 control-label" v-if="eventGroupDetail.eventGroupType == 2"> Event Types </label>
                <div class="col-sm-4" v-if="eventGroupDetail.eventGroupType == 2">
                  <el-form-item
                    prop="eventTypes"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="eventGroupDetail.eventTypes" clearable>
                      <el-option v-for="item in eventTypeObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <el-collapse v-model="activeNamesBasis">
                  <el-collapse-item title="Basis Information" name="1">
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Event title </label>
                      <div class="col-sm-4">
                        <el-form-item
                          :prop="'langMap.' + index + '.title'"
                          :rules="{
                            required: true,
                            message: $t('message.required'),
                            trigger: 'blur',
                          }"
                        >
                          <el-input v-model="langItem.title" show-word-limit :maxlength="255"></el-input>
                        </el-form-item>
                      </div>
                      <label class="col-sm-2 control-label"> Sub-title </label>
                      <div class="col-sm-4">
                        <el-form-item
                          :prop="'langMap.' + index + '.subTitle'"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'blur',
                          }"
                        >
                          <el-input v-model="langItem.subTitle" show-word-limit :maxlength="100"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Event ID </label>
                      <div class="col-sm-4">
                        <el-form-item
                          prop="internetContentCode"
                          :rules="{
                            required: true,
                            message: $t('message.required'),
                            trigger: 'blur',
                          }"
                        >
                          <el-input v-model="eventGroupDetail.internetContentCode" show-word-limit :maxlength="100"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Start Date </label>
                      <div class="col-sm-4">
                        <el-form-item
                          prop="startDate"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <el-date-picker v-model="eventGroupDetail.startDate" type="date" value-format="yyyy-MM-dd" placeholder="startDate"> </el-date-picker>
                        </el-form-item>
                      </div>
                      <label class="col-sm-2 control-label"> End Date </label>
                      <div class="col-sm-4">
                        <el-form-item
                          prop="endDate"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <el-date-picker v-model="eventGroupDetail.endDate" type="date" value-format="yyyy-MM-dd" placeholder="endDate"> </el-date-picker>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Start Time </label>
                      <div class="col-sm-4">
                        <el-form-item
                          prop="startTime"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <el-time-picker
                            v-model="eventGroupDetail.startTime"
                            value-format="HH:mm"
                            :picker-options="{
                              format: 'HH:mm',
                            }"
                            placeholder="startTime"
                          >
                          </el-time-picker>
                        </el-form-item>
                      </div>
                      <label class="col-sm-2 control-label"> End Time </label>
                      <div class="col-sm-4">
                        <el-form-item
                          prop="endTime"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <el-time-picker
                            v-model="eventGroupDetail.endTime"
                            value-format="HH:mm"
                            :picker-options="{
                              format: 'HH:mm',
                            }"
                            placeholder="endTime"
                          >
                          </el-time-picker>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label" v-if="eventGroupDetail.eventGroupType == 1"> Duration for Filter </label>
                      <div class="col-sm-4" v-if="eventGroupDetail.eventGroupType == 1">
                        <el-form-item
                          prop="eventDuration"
                          :rules="{
                            required: eventGroupDetail.status == 10 ? true : false,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <el-select v-model="eventGroupDetail.eventDuration" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                            <el-option v-for="item in eventLengthObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label" v-if="eventGroupDetail.eventGroupType == 1"> Display Event Length </label>
                      <div class="col-sm-4" v-if="eventGroupDetail.eventGroupType == 1">
                        <el-form-item
                          prop="eventLength"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <!-- <el-input v-model="eventGroupDetail.eventLength"  show-word-limit :maxlength="100"></el-input> -->
                          <el-time-picker v-model="eventGroupDetail.eventLength" format="HH:mm" value-format="HH:mm:ss"></el-time-picker>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="" style="margin-bottom: 15px">
                      <el-collapse-item title="Date Details" name="2">
                        <div class="form-group">
                          <label class="col-sm-2 control-label"> Date Details Page Title </label>
                          <div class="col-sm-10">
                            <el-form-item
                              :prop="'langMap.' + index + '.dateDetailsTitle'"
                              :rules="{
                                required: false,
                                message: $t('message.required'),
                                trigger: 'blur',
                              }"
                            >
                              <el-input type="textarea" show-word-limit maxlength="1000" :autosize="{ minRows: 2, maxRows: 4 }" v-model="langItem.dateDetailsTitle"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-sm-2 control-label"> Date Details Page Content </label>
                          <div class="col-sm-10">
                            <el-form-item
                              :prop="'langMap.' + index + '.dateDetailsContent'"
                              :rules="{
                                required: false,
                                message: $t('message.required'),
                                trigger: 'blur',
                              }"
                            >
                              <el-input type="textarea" show-word-limit maxlength="1000" :autosize="{ minRows: 2, maxRows: 4 }" v-model="langItem.dateDetailsContent"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-sm-2 control-label"> Event Records List </label>
                          <div class="col-sm-10">
                            <div>
                              <div class="sortable-list agile-list" style="max-height: 600px; overflow: auto; margin-bottom: 15px">
                                <div v-for="(task, index) in eventGroupDetail.eventRecords.records" class="dragObj">
                                  <div style="padding: 5px">
                                    <span style="display: inline-block">Event Title: {{ getObject(task.langMap, langItem.langCode).title }}</span>
                                  </div>
                                  <div style="padding: 5px">
                                    <span style="display: inline-block">Date: {{ showDate(task.dateJson.startDate) }} - {{ showDate(task.dateJson.endDate) }}</span>
                                  </div>
                                  <div style="padding: 5px">
                                    <span style="display: inline-block">Start Time: {{ task.dateJson.startTime }}</span>
                                  </div>
                                  <div style="padding: 5px">
                                    <span style="display: inline-block">End Time: {{ task.dateJson.endTime }}</span>
                                  </div>
                                  <a class="pull-right btn btn-xs btn-white" style="position: absolute; top: 10px; right: 10px" @click="deleteObj(eventGroupDetail.eventRecords.records, index)"
                                    ><i class="fa fa-trash-o"></i
                                  ></a>
                                  <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventRecords.records, 6, index)"><i class="fa fa-pencil"></i></a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12 text-right pad-b-15">
                            <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventRecords.records, 6)">Add</div>
                          </div>
                        </div>
                        <!-- <div class="form-group">
                          <label class="col-sm-2 control-label">
                          </label>
                          <div class="col-sm-10">
                            <div>
                              <div 
                                class="sortable-list agile-list"
                                style="max-height: 600px;overflow: auto;margin-bottom: 15px;"
                                >
                                 <div v-for="(groupRecord,index) in eventGroupDetail.eventRecords.groupRecords"  class="row margin-0" style="padding: 10px;position: relative;">
                                    <div style="padding: 5px">
                                        <span style="display: inline-block;">Group Title: {{getObject(groupRecord.langMap,langItem.langCode).title}}</span> 
                                    </div>
                                    <div class="col-sm-12">
                                      <div>
                                        <div 
                                          class="sortable-list agile-list"
                                          style="max-height: 600px;overflow: auto;margin-bottom: 15px;"
                                          >
                                           <div v-for="(record,index2) in groupRecord.records" class="dragObj">
                                               <div style="padding: 5px">
                                                  <span style="display: inline-block;">Event Title: {{getObject(record.langMap,langItem.langCode).title}}</span> 
                                              </div>
                                              <div style="padding: 5px">
                                                  <span style="display: inline-block;">Date: {{showDate(record.dateJson.startDate)}} - {{showDate(record.dateJson.endDate)}}</span> 
                                              </div>
                                              <div style="padding: 5px">
                                                  <span style="display: inline-block;">Start Time: {{record.dateJson.startTime}}</span> 
                                              </div>
                                              <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;" @click="deleteObj(groupRecord.records,index2)"><i class="fa fa-trash-o" ></i></a>
                                              <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(groupRecord.records,6,index2)"><i class="fa fa-pencil"></i></a>
                                           </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-sm-12 text-right pad-b-15">
                                        <div class="btn btn-primary" @click="addGroupEvent(groupRecord.records,6)">Add</div>
                                    </div>
                                    <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;" @click="deleteObj(eventGroupDetail.eventRecords.groupRecords,index)"><i class="fa fa-trash-o" ></i></a>
                                    <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventRecords.groupRecords,15,index)"><i class="fa fa-pencil"></i></a>
                                 </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12 text-right pad-b-15">
                              <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventRecords.groupRecords,15)">Add Group</div>
                          </div>
                        </div> -->
                      </el-collapse-item>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Venue </label>
                      <div class="col-sm-4">
                        <el-form-item
                          prop="venue"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <el-select v-model="eventGroupDetail.venue" multiple clearable v-bind:placeholder="$t('message.PleaseSelect')">
                            <el-option v-for="item in venueObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Address </label>
                      <div class="col-sm-10">
                        <div v-for="(task, k) in eventGroupDetail.eventAddress" class="dragObj">
                          <div class="form-group">
                            <label class="col-sm-2 control-label"> Type </label>
                            <div class="col-sm-10">
                              <el-select v-model="task.type" clearable>
                                <el-option v-for="item in typeAddressObj" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                              </el-select>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="col-sm-2 control-label"> Name </label>
                            <div class="col-sm-10">
                              <el-input v-model="getObject(task.langMap, langItem.langCode).name" show-word-limit></el-input>
                            </div>
                          </div>
                          <div class="form-group" v-if="task.type == 'URL'">
                            <label class="col-sm-2 control-label"> URL </label>
                            <div class="col-sm-10">
                              <el-input v-model="getObject(task.langMap, langItem.langCode).url" show-word-limit></el-input>
                            </div>
                          </div>
                          <div class="form-group" v-if="task.type == 'POI'">
                            <label class="col-sm-2 control-label"> POI </label>
                            <div class="col-sm-10">
                              <div v-if="task.poi">
                                <div style="padding: 5px">
                                  <span style="display: inline-block"> {{ getObject(task.poi.langMap, "en_US").name }}</span>
                                </div>
                              </div>
                              <div class="col-sm-12 text-right pad-b-15">
                                <div class="btn btn-primary" @click="selectPOI(task.poi, k, true)">Select POI</div>
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white" style="position: absolute; top: 10px; right: 10px" @click="deleteObj(eventGroupDetail.eventAddress, k)"
                            ><i class="fa fa-trash-o"></i
                          ></a>
                        </div>
                      </div>
                      <div class="col-sm-12 text-right pad-b-15">
                        <div class="btn btn-primary" @click="addAddress(eventGroupDetail.eventAddress)">Add Address</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Official Website </label>
                      <div class="col-sm-10">
                        <el-form-item
                          :prop="'langMap.' + index + '.officialWebsite'"
                          :rules="{
                            required: false,
                            message: $t('message.required'),
                            trigger: 'blur',
                          }"
                        >
                          <el-input v-model="langItem.officialWebsite" show-word-limit :maxlength="300"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Official display name </label>
                      <div class="col-sm-10">
                        <el-form-item
                          :prop="'langMap.' + index + '.officialDisplayName'"
                          :rules="{
                            required: langItem.officialWebsite ? true : false,
                            message: $t('message.required'),
                            trigger: 'blur',
                          }"
                        >
                          <el-input v-model="langItem.officialDisplayName" show-word-limit :maxlength="300"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Description </label>
                      <div class="col-sm-10">
                        <div>
                          <ckeditor :editor="editor" @ready="onReady" v-model="langItem.description" :config="editorConfig3"></ckeditor>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> Curatorial Statement </label>
                      <div class="col-sm-10">
                        <div>
                          <ckeditor :editor="editor" @ready="onReady" v-model="langItem.curatorialStatement" :config="editorConfig1"></ckeditor>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label"> M+ Admission Ticket Required </label>
                      <div class="col-sm-4">
                        <div style="padding-top: 7px">
                          <el-switch v-model="eventGroupDetail.admissionTicketRequiredToggle"> </el-switch>
                        </div>
                      </div>
                      <div class="col-sm-4" v-if="eventGroupDetail.admissionTicketRequiredToggle">
                        <span style="padding-right: 15px">Event Name: {{ eventGroupDetail.admissionTicketRequiredEvent.titleen_US }}</span>
                        <span><el-button @click="selectEvent2()">Select Event</el-button></span>
                        <el-form-item
                          prop="admissionTicketRequiredEventId"
                          :rules="{
                            required: true,
                            message: $t('message.required'),
                            trigger: 'change',
                          }"
                        >
                          <el-input style="display: none" v-model="eventGroupDetail.admissionTicketRequiredEventId"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div v-if="eventGroupDetail.eventGroupType != 1">
                      <div class="form-group">
                        <label class="col-sm-2 control-label" v-if="!eventGroupDetail.isThirdParty"> Admission Status </label>
                        <div class="col-sm-4" v-if="!eventGroupDetail.isThirdParty">
                          <el-form-item
                            prop="admissionStatus"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-select v-model="eventGroupDetail.admissionStatus" v-bind:placeholder="$t('message.PleaseSelect')">
                              <el-option v-for="item in admissionStatusObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <label class="col-sm-2 control-label"> Label </label>
                        <div class="col-sm-4">
                          <el-form-item
                            prop="label"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-select v-model="eventGroupDetail.label" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                              <el-option v-for="item in labelObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Duration for Filter </label>
                        <div class="col-sm-4">
                          <el-form-item
                            prop="eventDuration"
                            :rules="{
                              required: eventGroupDetail.status == 10 ? true : false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-select v-model="eventGroupDetail.eventDuration" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                              <el-option v-for="item in eventLengthObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Display Event Length </label>
                        <div class="col-sm-4">
                          <el-form-item
                            prop="eventLength"
                            :rules="{
                              required: eventGroupDetail.status == 10 ? true : false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <!-- <el-input v-model="eventGroupDetail.eventLength"  show-word-limit :maxlength="100"></el-input> -->
                            <el-time-picker v-model="eventGroupDetail.eventLength" format="HH:mm" value-format="HH:mm:ss"></el-time-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group" v-if="eventGroupDetail.eventGroupType == 2">
                        <label class="col-sm-2 control-label"> Environment </label>
                        <div style="padding: 0 15px 0 15px; display: inline-block">
                          <label class="control-label"> Indoor </label>
                          <div style="padding: 7px 0 0 15px; display: inline-block">
                            <el-switch v-model="eventGroupDetail.indoor"> </el-switch>
                          </div>
                        </div>
                        <div style="padding: 0 15px 0 30px; display: inline-block">
                          <label class="control-label"> Outdoor </label>
                          <div style="padding: 7px 0 0 15px; display: inline-block">
                            <el-switch v-model="eventGroupDetail.outdoor"> </el-switch>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Event Language </label>
                        <div class="col-sm-4">
                          <el-form-item
                            prop="eventLanguage"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-select v-model="eventGroupDetail.eventOtherLanguage" clearable multiple filterable v-bind:placeholder="$t('message.PleaseSelect')">
                              <el-option v-for="item in languageObj" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item
                            :prop="'langMap.' + index + '.eventOtherLanguage'"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-input v-model="langItem.eventLanguage" placeholder="Other Language" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Interpretation Language </label>
                        <div class="col-sm-4">
                          <el-form-item
                            prop="interpretationLanguage"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-select v-model="eventGroupDetail.interpretationLanguage" clearable multiple filterable v-bind:placeholder="$t('message.PleaseSelect')">
                              <el-option v-for="item in languageObj" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item
                            :prop="'langMap.' + index + '.interpretationOtherLanguage'"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-input v-model="langItem.interpretationOtherLanguage" placeholder="Other Language" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Subtitle Language </label>
                        <div class="col-sm-4">
                          <el-form-item
                            prop="subTitleLanguage"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-select v-model="eventGroupDetail.subTitleLanguage" clearable multiple filterable v-bind:placeholder="$t('message.PleaseSelect')">
                              <el-option v-for="item in languageObj" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item
                            :prop="'langMap.' + index + '.subTitleOtherLanguage'"
                            :rules="{
                              required: false,
                              message: $t('message.required'),
                              trigger: 'change',
                            }"
                          >
                            <el-input v-model="langItem.subTitleOtherLanguage" placeholder="Other Language" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Ticket Price - Free </label>
                        <div class="col-sm-4">
                          <div style="padding-top: 7px">
                            <el-switch v-model="eventGroupDetail.ticketFree"> </el-switch>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Ticket Price - Multi Prices </label>
                        <div class="col-sm-4">
                          <div>
                            <el-input type="number" v-model="price">
                              <el-button slot="append" @click="addPrices">Add</el-button>
                            </el-input>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"></label>
                        <div class="col-sm-10">
                          <ul class="tag-list" style="padding: 0">
                            <li v-for="(data, _index) in eventGroupDetail.ticketMultiPrices">
                              <a
                                ><span style="padding-right: 15px">{{ data | commaFormat | priceFormat }}</span> <i class="fa fa-trash-o" @click="deletePriceEvent(_index)"></i
                              ></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Ticket Price Details </label>
                        <div class="col-sm-10">
                          <div>
                            <ckeditor :editor="editor" @ready="onReady" v-model="langItem.ticketPriceDetail" :config="editorConfig4"></ckeditor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group">
                <el-collapse>
                  <el-collapse-item title="Visuals" name="3">
                    <div class="col-sm-12">
                      <draggable
                        class="sortable-list agile-list"
                        v-model="eventGroupDetail.eventVisual"
                        @start="drag = true"
                        @end="drag = false"
                        style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                      >
                        <li class="" v-for="(urlItem, i) in eventGroupDetail.eventVisual">
                          <div class="row margin-0" style="padding: 0px !important">
                            <div class="form-group margin-0" v-if="urlItem.visualType == 'video'">
                              <label class="col-sm-2 control-label">Video URL Field</label>
                              <div class="col-sm-10">
                                <div class="pad-t-7">
                                  {{ getObject(urlItem.langMap, langItem.langCode).image }}
                                </div>
                              </div>
                            </div>
                            <div class="form-group margin-0" v-else>
                              <label class="col-sm-2 control-label">Image</label>
                              <div class="col-sm-10">
                                <div class="pad-t-7 col-sm-3">
                                  <img style="width: 100%" v-bind:src="getObject(urlItem.langMap, langItem.langCode).image" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventVisual, i)"><i class="fa fa-trash-o"></i></a>
                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventVisual, 4, i)"><i class="fa fa-pencil"></i></a>
                        </li>
                      </draggable>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15">
                      <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventVisual, 4)">Add</div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group" v-if="eventGroupDetail.eventGroupType == 2">
                <el-collapse>
                  <el-collapse-item title="Highlight Items List" name="4">
                    <div class="col-sm-12">
                      <ul class="sortable-list agile-list">
                        <li class="" v-for="(enquiry, i) in eventGroupDetail.eventHighlightItem">
                          <div class="row margin-0" style="padding: 0px !important">
                            <div class="form-group margin-0">
                              <label class="col-sm-2 control-label">Highlight Items Group Title</label>
                              <div class="col-sm-10">
                                <div class="pad-t-7">
                                  {{ getObject(enquiry.langMap, langItem.langCode).name }}
                                </div>
                              </div>
                            </div>
                            <div class="form-group margin-0">
                              <label class="col-sm-2 control-label">Highlights</label>
                              <div class="col-sm-10">
                                <div class="col-sm-12" style="padding: 0 !important">
                                  <ul class="sortable-list agile-list">
                                    <li class="" v-for="(highlight, index) in eventGroupDetail.eventHighlightItem[i].highlights">
                                      <div class="row margin-0" style="padding: 0px !important">
                                        <div class="form-group margin-0">
                                          <label class="col-sm-2 control-label">Highlight Items Title</label>
                                          <div class="col-sm-10">
                                            <div class="pad-t-7" v-html="getObject(highlight.langMap, langItem.langCode).title"></div>
                                          </div>
                                        </div>
                                        <div class="form-group margin-0">
                                          <label class="col-sm-2 control-label">Image</label>
                                          <div class="col-sm-10">
                                            <div class="pad-t-7 col-sm-3">
                                              <img style="width: 100%" v-bind:src="getObject(highlight.langMap, langItem.langCode).image" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventHighlightItem[i].highlights, index)"
                                        ><i class="fa fa-trash-o"></i
                                      ></a>
                                      <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventHighlightItem[i].highlights, 8, index)"><i class="fa fa-pencil"></i></a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="col-sm-12 text-right">
                                <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventHighlightItem[i].highlights, 8)">Add Highlight Items</div>
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventHighlightItem, i)"><i class="fa fa-trash-o"></i></a>
                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventHighlightItem, 7, i)"><i class="fa fa-pencil"></i></a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15">
                      <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventHighlightItem, 7)">Add Group</div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group" v-if="eventGroupDetail.eventGroupType != 3">
                <el-collapse>
                  <el-collapse-item title="Artists" name="5">
                    <div class="col-sm-12">
                      <ul class="sortable-list agile-list">
                        <li class="" v-for="(enquiry, i) in eventGroupDetail.eventArtist">
                          <div class="row margin-0" style="padding: 0px !important">
                            <div class="form-group margin-0">
                              <label class="col-sm-2 control-label">Group Title</label>
                              <div class="col-sm-10">
                                <div class="pad-t-7">
                                  {{ getObject(enquiry.langMap, langItem.langCode).name }}
                                </div>
                              </div>
                            </div>
                            <div class="form-group margin-0">
                              <label class="col-sm-2 control-label">Artists</label>
                              <div class="col-sm-10">
                                <div class="col-sm-12" style="padding: 0 !important">
                                  <ul class="sortable-list agile-list">
                                    <li class="" v-for="(highlight, index) in eventGroupDetail.eventArtist[i].artists">
                                      <div class="row margin-0" style="padding: 0px !important">
                                        <div class="form-group margin-0">
                                          <label class="col-sm-2 control-label">Artist Name</label>
                                          <div class="col-sm-10">
                                            <div class="pad-t-7" v-html="getObject(highlight.langMap, langItem.langCode).name"></div>
                                          </div>
                                        </div>
                                        <div class="form-group margin-0">
                                          <label class="col-sm-2 control-label">Image</label>
                                          <div class="col-sm-10">
                                            <div class="pad-t-7 col-sm-3">
                                              <img style="width: 100%" v-bind:src="getObject(highlight.langMap, langItem.langCode).image" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventArtist[i].artists, index)"><i class="fa fa-trash-o"></i></a>
                                      <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventArtist[i].artists, 10, index)"><i class="fa fa-pencil"></i></a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="col-sm-12 text-right">
                                <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventArtist[i].artists, 10)">Add Artist</div>
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventArtist, i)"><i class="fa fa-trash-o"></i></a>
                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventArtist, 9, i)"><i class="fa fa-pencil"></i></a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15">
                      <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventArtist, 9)">Add Group</div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group" v-if="eventGroupDetail.eventGroupType != 3">
                <el-collapse>
                  <el-collapse-item title="Programmes List" name="15">
                    <div class="col-sm-12">
                      <ul class="sortable-list agile-list">
                        <li class="" v-for="(enquiry, i) in eventGroupDetail.eventOtherProgramme">
                          <div class="row margin-0" style="padding: 0px !important">
                            <div class="form-group">
                              <label class="col-sm-2 control-label">Programme Title</label>
                              <div class="col-sm-10">
                                <div class="pad-t-7">
                                  {{ getObject(enquiry.langMap, langItem.langCode).programmeName }}
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-sm-2 control-label">Programme list</label>
                              <div class="col-sm-10">
                                <draggable
                                  class="sortable-list connectList0 agile-list"
                                  style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                                  v-model="enquiry.eventList"
                                  group="people"
                                  @start="drag = true"
                                  @end="drag = false"
                                >
                                  <div v-for="(task, index) in enquiry.eventList" class="dragObj">
                                    <div style="padding: 5px">
                                      <span style="display: inline-block">Programme Title: {{ getObject(task.langMap, langItem.langCode).title }}</span>
                                    </div>
                                    <div style="padding: 5px">
                                      <span style="display: inline-block">Date: {{ task["startDate"] }} - {{ task["endDate"] }}</span>
                                    </div>
                                    <div style="padding: 5px">
                                      <span style="display: inline-block">Status: {{ statusStr[task.status] }}</span>
                                    </div>
                                    <a class="pull-right btn btn-xs btn-white" style="position: absolute; top: 10px; right: 10px" @click="deleteObj(enquiry.eventList, index)"
                                      ><i class="fa fa-trash-o"></i
                                    ></a>
                                  </div>
                                </draggable>
                              </div>
                            </div>
                            <div class="col-sm-12 text-right pad-b-15">
                              <div class="btn btn-primary" @click="selectEvent(enquiry.eventList, 1)">Add Event</div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventOtherProgramme, i)"><i class="fa fa-trash-o"></i></a>
                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventOtherProgramme, 5, i)"><i class="fa fa-pencil"></i></a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15">
                      <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventOtherProgramme, 5)">Add Programme</div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group">
                <el-collapse>
                  <el-collapse-item title="Supplementary Information" name="13">
                    <div class="" style="margin: 15px">
                      <el-collapse-item title="Others Header" name="7">
                        <div class="col-sm-12">
                          <ul class="sortable-list agile-list">
                            <li class="" v-for="(other, i) in eventGroupDetail.eventOther">
                              <div class="row margin-0" style="padding: 0px !important">
                                <div class="form-group margin-0">
                                  <label class="col-sm-2 control-label">Others Title</label>
                                  <div class="col-sm-10">
                                    <div class="pad-t-7">
                                      {{ getObject(other.langMap, langItem.langCode).sectionTitle }}
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group margin-0">
                                  <label class="col-sm-2 control-label">Others Content</label>
                                  <div class="col-sm-10">
                                    <div class="pad-t-7" v-html="getObject(other.langMap, langItem.langCode).content"></div>
                                  </div>
                                </div>
                              </div>
                              <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventOther, i)"><i class="fa fa-trash-o"></i></a>
                              <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventOther, 0, i)"><i class="fa fa-pencil"></i></a>
                            </li>
                          </ul>
                        </div>
                        <div class="col-sm-12 text-right pad-b-15">
                          <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventOther, 0)">Add Others</div>
                        </div>
                      </el-collapse-item>
                      <el-collapse-item title="Enquiry Header" name="8">
                        <div class="col-sm-12">
                          <ul class="sortable-list agile-list">
                            <li class="" v-for="(enquiryGroup, i) in eventGroupDetail.eventEnquiry">
                              <div class="row margin-0" style="padding: 0px !important">
                                <div class="form-group margin-0">
                                  <label class="col-sm-2 control-label">Enquiry Group Title</label>
                                  <div class="col-sm-10">
                                    <div class="pad-t-7">
                                      {{ getObject(enquiryGroup.langMap, langItem.langCode).title }}
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group margin-0">
                                  <label class="col-sm-2 control-label">Enquirys</label>
                                  <div class="col-sm-10">
                                    <div class="col-sm-12" style="padding: 0 !important">
                                      <ul class="sortable-list agile-list">
                                        <li class="" v-for="(enquiry, index) in eventGroupDetail.eventEnquiry[i].enquirys">
                                          <div class="row margin-0" style="padding: 0px !important">
                                            <div class="form-group margin-0" v-if="getObject(enquiry.langMap, langItem.langCode).contactPerson">
                                              >
                                              <label class="col-sm-2 control-label">Contact Person</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7">
                                                  {{ getObject(enquiry.langMap, langItem.langCode).contactPerson }}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="form-group margin-0" v-if="enquiry.phoneNumber">
                                              <label class="col-sm-2 control-label">Phone</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7">
                                                  {{ enquiry.phoneNumber }}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="form-group margin-0" v-if="enquiry.emailAddress">
                                              <label class="col-sm-2 control-label">Email</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7">
                                                  {{ enquiry.emailAddress }}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventEnquiry[i].enquirys, index)"><i class="fa fa-trash-o"></i></a>
                                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventEnquiry[i].enquirys, 14, index)"><i class="fa fa-pencil"></i></a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="col-sm-12 text-right">
                                    <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventEnquiry[i].enquirys, 14)">Add Enquiry</div>
                                  </div>
                                </div>
                              </div>
                              <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventEnquiry, i)"><i class="fa fa-trash-o"></i></a>
                              <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventEnquiry, 1, i)"><i class="fa fa-pencil"></i></a>
                            </li>
                          </ul>
                        </div>
                        <div class="col-sm-12 text-right pad-b-15">
                          <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventEnquiry, 1)">Add Enquiry Group</div>
                        </div>
                      </el-collapse-item>
                      <el-collapse-item title="Accessibility Services Header" name="9">
                        <!-- <div class="form-group">
                          <label class="col-sm-2 control-label">
                            Accessibility Services 
                          </label>
                          <div class="col-sm-10">
                            <div>
                              <el-select v-model="eventGroupDetail.accessibilityServices" clearable multiple v-bind:placeholder='$t("message.PleaseSelect")'>
                                  <el-option 
                                  v-for="item in accessibilityObj"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item.value">
                                  </el-option>
                              </el-select>
                            </div>
                          </div>
                        </div> -->
                        <div class="form-group">
                          <label class="col-sm-2 control-label"> Accessibility Services Content </label>
                          <div class="col-sm-10 pad-b-15">
                            <ckeditor :editor="editor" @ready="onReady" v-model="langItem.accessibilityServicesContent" :config="editorConfig2"></ckeditor>
                          </div>
                        </div>
                      </el-collapse-item>
                      <el-collapse-item title="Visitor's information Header" name="10">
                        <div class="col-sm-12 pad-b-15">
                          <ckeditor :editor="editor" @ready="onReady" v-model="langItem.visitorInformation" :config="editorConfig2"></ckeditor>
                        </div>
                      </el-collapse-item>
                      <el-collapse-item title="Organisation Header" name="11">
                        <div class="col-sm-12">
                          <ul class="sortable-list agile-list">
                            <li class="" v-for="(enquiry, i) in eventGroupDetail.eventOrganization">
                              <div class="row margin-0" style="padding: 0px !important">
                                <div class="form-group margin-0">
                                  <label class="col-sm-2 control-label">Organisation Group Title</label>
                                  <div class="col-sm-10">
                                    <div class="pad-t-7">
                                      {{ getObject(enquiry.langMap, langItem.langCode).name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group margin-0">
                                  <label class="col-sm-2 control-label">Organizations</label>
                                  <div class="col-sm-10">
                                    <div class="col-sm-12" style="padding: 0 !important">
                                      <ul class="sortable-list agile-list">
                                        <li class="" v-for="(organization, index) in eventGroupDetail.eventOrganization[i].organizations">
                                          <div class="row margin-0" style="padding: 0px !important">
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Organisation Name</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7">
                                                  {{ getObject(organization.langMap, langItem.langCode).name }}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Image</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7 col-sm-3">
                                                  <img style="width: 100%" v-bind:src="getObject(organization.langMap, langItem.langCode).image" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventOrganization[i].organizations, index)"
                                            ><i class="fa fa-trash-o"></i
                                          ></a>
                                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventOrganization[i].organizations, 3, index)"
                                            ><i class="fa fa-pencil"></i
                                          ></a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="col-sm-12 text-right">
                                    <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventOrganization[i].organizations, 3)">Add Organisation</div>
                                  </div>
                                </div>
                              </div>
                              <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(eventGroupDetail.eventOrganization, i)"><i class="fa fa-trash-o"></i></a>
                              <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(eventGroupDetail.eventOrganization, 2, i)"><i class="fa fa-pencil"></i></a>
                            </li>
                          </ul>
                        </div>
                        <div class="col-sm-12 text-right pad-b-15">
                          <div class="btn btn-primary" @click="addGroupEvent(eventGroupDetail.eventOrganization, 2)">Add Organisation Group</div>
                        </div>
                      </el-collapse-item>
                      <el-collapse-item title="Remarks Header" name="12">
                        <div class="col-sm-12 pad-b-15">
                          <ckeditor :editor="editor" @ready="onReady" v-model="langItem.remarks" :config="editorConfig"></ckeditor>
                        </div>
                      </el-collapse-item>
                      <div class="form-group" style="padding-top: 15px">
                        <label class="col-sm-2 control-label"> Select Tags </label>
                        <div class="col-sm-10">
                          <div>
                            <el-select v-model="getObject(eventGroupDetail.eventTag, langItem.langCode).tagIds" clearable filterable multiple v-bind:placeholder="$t('message.PleaseSelect')">
                              <el-option v-for="item in tagsList" :key="item.id" v-if="item.langCode == langItem.langCode && item.name" :label="item.name" :value="item.id"> </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> new Tags </label>
                        <div class="col-sm-10">
                          <div>
                            <el-input v-model="tag" show-word-limit :maxlength="100"><el-button slot="append" @click="addTags(langItem.langCode)">Add</el-button></el-input>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"></label>
                        <div class="col-sm-10">
                          <ul class="tag-list" style="padding: 0">
                            <li v-for="(data, k) in getObject(eventGroupDetail.eventTag, langItem.langCode).tags">
                              <a
                                ><span style="padding-right: 15px">{{ data }}</span> <i class="fa fa-trash-o" @click="deleteObj(getObject(eventGroupDetail.eventTag, langItem.langCode).tags, k)"></i
                              ></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Recommend Event Type </label>
                        <div class="col-sm-5 pad-t-7">
                          <div>
                            <el-radio v-model="eventGroupDetail.recommendEventType" label="1">Default</el-radio>
                            <el-radio v-model="eventGroupDetail.recommendEventType" label="2">Manual Control</el-radio>
                          </div>
                        </div>
                      </div>
                      <div class="form-group" v-if="eventGroupDetail.recommendEventType == 2">
                        <label class="col-sm-2 control-label"> Recommend Events </label>
                        <div class="col-sm-10">
                          <div>
                            <draggable
                              class="sortable-list connectList0 agile-list"
                              style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                              v-model="eventGroupDetail.recommendEventList"
                              group="people"
                              @start="drag = true"
                              @end="drag = false"
                            >
                              <div v-for="(task, index) in eventGroupDetail.recommendEventList" class="dragObj">
                                <div style="padding: 5px">
                                  <span style="display: inline-block">Name: {{ task["titleen_US"] }}</span>
                                </div>
                                <a class="pull-right btn btn-xs btn-white" style="position: absolute; top: 10px; right: 10px" @click="deleteObj(eventGroupDetail.recommendEventList, index)"
                                  ><i class="fa fa-trash-o"></i
                                ></a>
                              </div>
                            </draggable>
                          </div>
                        </div>
                        <div class="col-sm-12 text-right pad-b-15">
                          <div class="btn btn-primary" @click="selectEvent(eventGroupDetail.recommendEventList, 0)">Add</div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="Ticket Remarks and T&C" name="32">
                    <div class="col-sm-12 pad-b-15">
                      <ckeditor :editor="editor" @ready="onReady" v-model="langItem.ticketRemark" :config="editorConfig"></ckeditor>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Status </label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="status"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="eventGroupDetail.status" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-for="item in statusObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <label class="col-sm-2 control-label"> Scheduler </label>
                <div class="col-sm-4">
                  <div>
                    <el-date-picker v-model="eventGroupDetail.publishDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="publishDate"> </el-date-picker>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Unpublish Date </label>
                <div class="col-sm-4">
                  <div>
                    <el-date-picker v-model="eventGroupDetail.unpublishDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="unpublishDate"> </el-date-picker>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> External Link </label>
                <div class="col-sm-4">
                  <div>
                    <el-input type="text" show-word-limit maxlength="500" v-model="langItem.externalLink"></el-input>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Updated time </label>
                <div class="col-sm-4">
                  <div>
                    <el-input disabled v-model="eventGroupDetail.updatedTime"></el-input>
                  </div>
                </div>
                <label class="col-sm-2 control-label"> Updated by </label>
                <div class="col-sm-4">
                  <div>
                    <el-input disabled v-model="eventGroupDetail.updatedBy"></el-input>
                  </div>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div
                      class="btn btn-primary"
                      v-if="(!$route.query.id && checkPermission('EVENT_GROUP_LIST_NEW')) || ($route.query.id && checkPermission('EVENT_GROUP_LIST_UPDATE'))"
                      @click="checkEvent()"
                    >
                      {{ $t("message.Save") }}
                    </div>
                    <div class="btn btn-white" @click="showWarning()">
                      {{ $t("message.Cancel") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
const upload = require("../upload");
import draggable from "vuedraggable";

import VJstree from "vue-jstree";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      eventGroupDetail: {
        eventGroupType: "",
        eventTypes: "",
        venue: "",
        recommendEventType: "1",
        eventLanguage: "",
        subTitleLanguage: "",
        admissionTicketRequiredToggle: false,
        admissionTicketRequiredEvent: {},
        admissionTicketRequiredEventId: "",
        langMap: [
          {
            langCode: "en_US",
            remarks: "",
            accessibilityServicesContent: "",
            visitorInformation: "",
            externalLink: "",
          },
          {
            langCode: "zh_CN",
            remarks: "",
            accessibilityServicesContent: "",
            visitorInformation: "",
            externalLink: "",
          },
          {
            langCode: "zh_HK",
            remarks: "",
            accessibilityServicesContent: "",
            visitorInformation: "",
            externalLink: "",
          },
        ],
        eventOther: [],
        eventEnquiry: [],
        eventOrganization: [],
        eventVisual: [],
        eventProgramme: [],
        eventAddress: [],
        eventTag: [
          {
            langCode: "en_US",
            tagIds: [],
            tags: "",
          },
          {
            langCode: "zh_CN",
            tagIds: [],
            tags: "",
          },
          {
            langCode: "zh_HK",
            tagIds: [],
            tags: "",
          },
        ],
        eventOtherProgramme: [],
        recommendEventList: [],
        eventRecords: {
          records: [],
          groupRecords: [],
        },
        eventHighlightItem: [],
        eventSchedule: [],
        foodPoiIds: [],
        eventArtist: [],
        ticketMultiPrices: [],
        startTime: "",
        endTime: "",
      },
      statusStr: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ["bold", "italic", "underline", "Link", "bulletedList", "numberedList"],
      },
      editorConfig1: {
        toolbar: ["bold", "italic", "underline", "bulletedList", "numberedList"],
      },
      editorConfig2: {
        toolbar: ["bold", "italic", "underline", "Link", "bulletedList", "numberedList", "imageUpload"],
        extraPlugins: [upload.MyCustomUploadAdapterPlugin],
      },
      editorConfig3: {
        toolbar: ["bold", "italic", "underline"],
      },
      editorConfig4: {
        toolbar: ["bold", "italic", "underline", "bulletedList", "numberedList", "imageUpload"],
        extraPlugins: [upload.MyCustomUploadAdapterPlugin],
      },
      editorConfig5: {
        toolbar: ["bold", "italic", "underline", "Link"],
      },
      tag: "",
      eventGroupTypeObj: [],
      eventTypeObj: [],
      eventLengthObj: [],
      venueObj: [],
      labelObj: [],
      admissionStatusObj: [],
      statusObj: [],
      repeatObj: [],
      accessibilityObj: [],
      languageObj: [],
      eventAndEventGroupList: [],
      tagsList: [],
      activeNamesBasis: ["2", "3"],
      price: "",
      venueList: [],
      showVenue: {
        1: this.$i18n.t("message.Xiqu Centre"),
        2: this.$i18n.t("message.Freespace"),
        3: this.$i18n.t("message.Art Park"),
        4: this.$i18n.t("message.Multi-venue"),
        5: this.$i18n.t("message.Out-of-district"),
        6: this.$i18n.t("message.M+ Pavillian"),
      },
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    eventGroupDetail: {
      handler: function (val, oldval) {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  filters: {
    priceFormat: function (value) {
      // 加上 $ 字號
      return "$" + value;
    },
    commaFormat: function (value) {
      // 加上千分位符號
      return value.toString().replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
        return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
      });
    },
  },
  components: {
    VJstree,
    draggable,
    "file-upload": fileupload,
  },
  created() {
    this.setObj();
    this.init();
  },
  mounted() {
    setTimeout(function () {
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    });
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    setObj: function () {
      this.eventGroupTypeObj = [
        {
          value: 1,
          label: this.$i18n.t("message.Series"),
        },
      ];
      this.statusStr = {
        0: "Draft",
        1: "Unpublish",
        2: "Expired",
        10: "Publish",
      };
      this.eventTypeObj = [
        {
          value: 1,
          label: "Performing Arts",
        },
        {
          value: 2,
          label: "Exhibitions",
        },
        {
          value: 3,
          label: "Talks / Forums",
        },
        {
          value: 4,
          label: "Guided Tour",
        },
        {
          value: 5,
          label: "Workshops",
        },
        {
          value: 6,
          label: "Screening",
        },
        {
          value: "7",
          label: "Festival",
        },
      ];
      this.typeAddressObj = [
        {
          label: "URL",
        },
        {
          label: "POI",
        },
      ];
      this.eventLengthObj = [
        {
          value: "1",
          label: "Short (<3 hours)",
        },
        {
          value: "2",
          label: "Medium (3-5 hours)",
        },
        {
          value: "3",
          label: "Long (>5 hours)",
        },
        {
          value: "4",
          label: "Full day",
        },
      ];
      this.labelObj = [
        {
          value: 1,
          label: "Popular",
        },
      ];
      this.statusObj = [
        {
          value: 0,
          label: "Draft",
        },
        {
          value: 10,
          label: "Publish",
        },
        {
          value: 1,
          label: "Unpublish",
        },
        {
          value: 2,
          label: "Expired",
        },
      ];
      this.accessibilityObj = [
        {
          value: "Wheelchair accessible seats",
        },
        {
          value: "Companion seats",
        },
        {
          value: "Cantonese audio description",
        },
        {
          value: "Sign language interpretation",
        },
      ];
      this.languageObj = [
        {
          value: "English",
        },
        {
          value: "Cantonese",
        },
        {
          value: "Mandarin",
        },
      ];
    },
    async venueListEvent() {
      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.status = 1;
      objdata.apiUrl = "/getVenueList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.venueList = data.data.resultList;
      this.venueObj = [];
      for (var i = 0; i < this.venueList.length; i++) {
        this.venueObj.push({
          value: this.venueList[i].id + "",
          label: this.getObject(this.venueList[i].langMap, this.langKey[0]).content,
        });
      }
    },
    async init() {
      let id = this.$route.query.id;
      this.eventGroupDetail.eventGroupType = parseInt(this.$route.query.type);
      if (id) {
        let obj = this.getAuthObj();
        obj.eventGroupId = id;
        obj.apiUrl = "/getEventGroupDetail";
        var data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        if (!data.data.result.venue) {
          data.data.result.venue = "";
        } else {
          data.data.result.venue = data.data.result.venue.split(",");
        }
        if (!data.data.result.admissionTicketRequiredEvent) {
          data.data.result.admissionTicketRequiredEvent = {
            titleen_US: "",
          };
        } else {
          data.data.result.admissionTicketRequiredEvent.langMap.forEach(item => {
            if (item.langCode == "en_US") {
              data.data.result.admissionTicketRequiredEvent.titleen_US = item.title;
            }
          });
        }
        if (data.data.result.eventLanguage) {
          data.data.result.eventLanguage = data.data.result.eventLanguage.split(",");
        }
        if (data.data.result.subTitleLanguage) {
          data.data.result.subTitleLanguage = data.data.result.subTitleLanguage.split(",");
        }
        if (data.data.result.interpretationLanguage) {
          data.data.result.interpretationLanguage = data.data.result.interpretationLanguage.split(",");
        }
        data.data.result.recommendEventType += "";
        if (data.data.result.ticketMultiPrices) {
          data.data.result.ticketMultiPrices = data.data.result.ticketMultiPrices.split(";");
        } else {
          data.data.result.ticketMultiPrices = [];
        }
        if (!data.data.result.eventRecords) {
          data.data.result.eventRecords = {
            records: [],
            groupRecords: [],
          };
        }
        if (!data.data.result.eventRecords.records) {
          data.data.result.eventRecords.records = [];
        }
        for (var i = 0; i < data.data.result.eventRecords.records.length; i++) {
          data.data.result.eventRecords.records[i].dateJson = JSON.parse(data.data.result.eventRecords.records[i].dateJson);
        }
        if (!data.data.result.eventRecords.groupRecords) {
          data.data.result.eventRecords.groupRecords = [];
        }
        for (var i = 0; i < data.data.result.eventRecords.groupRecords.length; i++) {
          for (var j = 0; j < data.data.result.eventRecords.groupRecords[i].records.length; j++) {
            data.data.result.eventRecords.groupRecords[i].records[j].dateJson = JSON.parse(data.data.result.eventRecords.groupRecords[i].records[j].dateJson);
          }
        }
        for (var i = 0; i < data.data.result.langMap.length; i++) {
          if (data.data.result.langMap[i].curatorialStatement == null) {
            data.data.result.langMap[i].curatorialStatement = "";
          }
          if (data.data.result.langMap[i].ticketPriceDetail == null) {
            data.data.result.langMap[i].ticketPriceDetail = "";
          }
          if (data.data.result.langMap[i].accessibilityServicesContent == null) {
            data.data.result.langMap[i].accessibilityServicesContent = "";
          }
          if (data.data.result.langMap[i].visitorInformation == null) {
            data.data.result.langMap[i].visitorInformation = "";
          }
          if (data.data.result.langMap[i].remarks == null) {
            data.data.result.langMap[i].remarks = "";
          }
        }

        data.data.result.eventProgramme = data.data.result.eventProgrammeList;

        for (var i = 0; i < data.data.result.foodPoiList.length; i++) {
          for (var j = 0; j < data.data.result.foodPoiList[i].langMap.length; j++) {
            if (data.data.result.foodPoiList[i].langMap[j].langCode == "en_US") {
              data.data.result.foodPoiList[i]["title" + "en_US"] = data.data.result.foodPoiList[i].langMap[j].name;
            }
          }
        }
        for (var i = 0; i < data.data.result.recommendEventList.length; i++) {
          for (var j = 0; j < data.data.result.recommendEventList[i].langMap.length; j++) {
            if (data.data.result.recommendEventList[i].langMap[j].langCode == "en_US") {
              data.data.result.recommendEventList[i]["title" + "en_US"] = data.data.result.recommendEventList[i].langMap[j].title;
            }
          }
        }
        data.data.result.foodPoiIds = data.data.result.foodPoiList;

        this.$set(this, "eventGroupDetail", data.data.result);
        var that = this;
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
      }
      this.tagListEvent();
      this.venueListEvent();
      this.getAdmissionStatusEvent();
    },
    async tagListEvent() {
      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.status = 1;
      objdata.apiUrl = "/getTagList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.tagsList = data.data.resultList;
    },
    async getAdmissionStatusEvent() {
      let objdata = this.getAuthObj();
      objdata.apiUrl = "/getAdmissionStatusList";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      data.data.resultList.forEach(item => {
        item.name = this.getObject(item.langMap, "en_US").content;
      });
      this.admissionStatusObj = data.data.resultList;
    },
    goBack() {
      this.$router.push({
        path: "/main/eventGroupList",
        query: { ...this.$route.query },
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    checkEvent: function () {
      this.$refs["eventGroupDetail"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      let obj = this.getAuthObj();
      for (var key in this.eventGroupDetail) {
        var detail = JSON.stringify(this.eventGroupDetail[key]);
        obj[key] = JSON.parse(detail);
      }
      obj.eventGroupId = this.eventGroupDetail.id;
      obj.langMap = JSON.stringify(obj.langMap);
      var eventProgrammeIds = [];
      for (var i = 0; i < obj.eventProgramme.length; i++) {
        eventProgrammeIds.push(obj.eventProgramme[i].id);
      }
      obj.eventProgramme = eventProgrammeIds;
      for (var i = 0; i < obj.eventOtherProgramme.length; i++) {
        obj.eventOtherProgramme[i].eventIds = [];
        for (var j = 0; j < obj.eventOtherProgramme[i].eventList.length; j++) {
          obj.eventOtherProgramme[i].eventIds.push(obj.eventOtherProgramme[i].eventList[j].id);
        }
        obj.eventOtherProgramme[i].eventList = [];
        obj.eventOtherProgramme[i].eventIds = obj.eventOtherProgramme[i].eventIds.join(",");
      }
      for (var i = 0; i < obj.eventRecords.records.length; i++) {
        obj.eventRecords.records[i].dateJson = JSON.stringify(obj.eventRecords.records[i].dateJson);
      }
      for (var i = 0; i < obj.eventRecords.groupRecords.length; i++) {
        for (var j = 0; j < obj.eventRecords.groupRecords[i].records.length; j++) {
          obj.eventRecords.groupRecords[i].records[j].dateJson = JSON.stringify(obj.eventRecords.groupRecords[i].records[j].dateJson);
        }
      }
      obj.eventRecords = JSON.stringify(obj.eventRecords);

      obj.eventAddress.forEach(item => {
        if (item.poi) {
          item.poiId = item.poi.id;
        }
        delete item["poi"];
      });
      obj.eventAddress = JSON.stringify(obj.eventAddress);

      var ids = [];
      for (var i = 0; i < obj.foodPoiIds.length; i++) {
        ids.push(obj.foodPoiIds[i].id);
      }
      obj.foodPoiIds = ids.join(",");

      obj.eventOtherProgramme = JSON.stringify(obj.eventOtherProgramme);
      obj.eventProgramme = obj.eventProgramme.join(",");
      obj.eventOther = JSON.stringify(obj.eventOther);
      obj.eventEnquiry = JSON.stringify(obj.eventEnquiry);
      obj.eventOrganization = JSON.stringify(obj.eventOrganization);
      obj.eventVisual = JSON.stringify(obj.eventVisual);
      obj.eventHighlightItem = JSON.stringify(obj.eventHighlightItem);

      for (var i = 0; i < obj.eventSchedule.length; i++) {
        obj.eventSchedule[i].eventIds = [];
        for (var j = 0; j < obj.eventSchedule[i].eventList.length; j++) {
          obj.eventSchedule[i].eventIds.push(obj.eventSchedule[i].eventList[j].id);
        }
        obj.eventSchedule[i].eventList = [];
        // obj.eventSchedule[i].eventIds = obj.eventSchedule[i].eventIds.join(',');
      }
      obj.eventSchedule = JSON.stringify(obj.eventSchedule);
      obj.eventArtist = JSON.stringify(obj.eventArtist);
      obj.eventTag.forEach(item => {
        if (item.tags) {
          item.tags = item.tags.join(";");
        }
      });
      obj.eventTag = JSON.stringify(obj.eventTag);
      obj.ticketMultiPrices = obj.ticketMultiPrices.join(";");
      var recommendEventIds = [];
      for (var i = 0; i < obj.recommendEventList.length; i++) {
        recommendEventIds.push(obj.recommendEventList[i].id);
      }
      obj.recommendEventIds = recommendEventIds.join(",");
      if (this.$route.query.id) {
        obj.apiUrl = "/updateEventGroup";
        var data = await this.$store.dispatch("apiEvent", obj);
      } else {
        obj.apiUrl = "/createEventGroup";
        var data = await this.$store.dispatch("apiEvent", obj);
      }
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.state.edit = false;

        this.$toastr.s("Save Success");
      }
    },
    Delete() {
      this.showWarning(1);
    },
    showDate(value) {
      if (!value) return "";
      var date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      return y + "-" + MM + "-" + d;
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.ids = this.$route.query.id;
        obj.apiUrl = "/deleteEventGroup";
        var data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
      } catch (err) {}
    },
    addPrices: function () {
      this.eventGroupDetail.ticketFree = false;
      this.eventGroupDetail.ticketMultiPrices.push(this.price);
      this.price = "";
    },
    deletePriceEvent: function (index) {
      this.$delete(this.eventGroupDetail.ticketMultiPrices, index);
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function (id) {
      this.venueObj = [];
      for (var i = 0; i < this.venueList.length; i++) {
        this.venueObj.push({
          value: this.venueList[i].id + "",
          label: this.getObject(this.venueList[i].langMap, this.langKey[id]).content,
        });
      }
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    editObj: function (obj, type, index) {
      this.addGroupEvent(obj, type, index);
    },
    deleteObj: function (obj, index) {
      obj.splice(index, 1);
    },
    selectEvent: function (obj, type) {
      var that = this;
      this.$store.commit("seteventlist", {
        callback: function (item) {
          that.$store.commit("seteventlist", { string: "", boolean: false });
          for (var i = 0; i < item.length; i++) {
            var canPush = true;
            for (var j = 0; j < obj.length; j++) {
              if (obj[j].id == item[i].id) {
                canPush = false;
              }
            }
            if (canPush) {
              obj.push(item[i]);
            }
          }
        },
        boolean: true,
        button: [],
      });
    },
    selectEvent2: function () {
      var that = this;
      this.$store.commit("seteventlist", {
        callback: function (item) {
          that.$store.commit("seteventlist", { string: "", boolean: false });
          that.eventGroupDetail.admissionTicketRequiredEvent = item[0];
          that.eventGroupDetail.admissionTicketRequiredEventId = item[0].id;
        },
        both: false,
        id: this.$route.query.id,
        boolean: true,
        button: [],
      });
    },
    selectPOI: function (obj, index, poi) {
      var that = this;
      this.$store.commit("setpoilist", {
        callback: function (item) {
          that.$store.commit("setpoilist", { string: "", boolean: false });
          if (poi && item.length) {
            that.eventGroupDetail.eventAddress[index].poi = item[0];
            return;
          }
          for (var i = 0; i < item.length; i++) {
            var canPush = true;
            for (var j = 0; j < obj.length; j++) {
              if (obj[j].id == item[i].id) {
                canPush = false;
              }
            }
            if (canPush) {
              obj.push(item[i]);
            }
          }
        },
        boolean: true,
        button: [],
      });
    },
    addTags(langCode) {
      if (!this.tag) return;
      if (!this.getObject(this.eventGroupDetail.eventTag, langCode).tags) {
        this.getObject(this.eventGroupDetail.eventTag, langCode).tags = [];
      }
      var tag = this.tag.split(";");
      tag.forEach(item => {
        this.getObject(this.eventGroupDetail.eventTag, langCode).tags.push(item);
      });
      this.tag = "";
    },
    addAddress(obj) {
      obj.push({
        type: "URL",
        poiId: "",
        poi: {},
        langMap: [
          {
            langCode: "en_US",
            name: "",
            url: "",
          },
          {
            langCode: "zh_CN",
            name: "",
            url: "",
          },
          {
            langCode: "zh_HK",
            name: "",
            url: "",
          },
        ],
      });
    },
    addGroupEvent: function (obj, objType, index) {
      var that = this;
      if (index != undefined) {
        var data = obj[index];
      } else if (objType == 0) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              sectionTitle: "",
              content: "",
            },
            {
              langCode: "zh_CN",
              sectionTitle: "",
              content: "",
            },
            {
              langCode: "zh_HK",
              sectionTitle: "",
              content: "",
            },
          ],
        };
      } else if (objType == 1) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              title: "",
            },
            {
              langCode: "zh_CN",
              title: "",
            },
            {
              langCode: "zh_HK",
              title: "",
            },
          ],
          enquirys: [],
        };
      } else if (objType == 14) {
        var data = {
          phoneNumber: "",
          emailAddress: "",
          langMap: [
            {
              langCode: "en_US",
              contactPerson: "",
            },
            {
              langCode: "zh_CN",
              contactPerson: "",
            },
            {
              langCode: "zh_HK",
              contactPerson: "",
            },
          ],
        };
      } else if (objType == 2) {
        var data = {
          organizations: [],
          langMap: [
            {
              langCode: "en_US",
              name: "",
            },
            {
              langCode: "zh_CN",
              name: "",
            },
            {
              langCode: "zh_HK",
              name: "",
            },
          ],
        };
      } else if (objType == 3) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              name: "",
            },
            {
              langCode: "zh_CN",
              name: "",
            },
            {
              langCode: "zh_HK",
              name: "",
            },
          ],
        };
      } else if (objType == 4) {
        var data = {
          visualType: "",
          langMap: [
            {
              langCode: "en_US",
              image: "",
            },
            {
              langCode: "zh_CN",
              image: "",
            },
            {
              langCode: "zh_HK",
              image: "",
            },
          ],
        };
      } else if (objType == 5) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              programmeName: "",
            },
            {
              langCode: "zh_CN",
              programmeName: "",
            },
            {
              langCode: "zh_HK",
              programmeName: "",
            },
          ],
          eventList: [],
        };
      } else if (objType == 6) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              title: "",
            },
            {
              langCode: "zh_CN",
              title: "",
            },
            {
              langCode: "zh_HK",
              title: "",
            },
          ],
          dateJson: {
            startDate: "",
            endDate: "",
            startTime: "00:00",
            endTime: "23:59",
            repeat: "",
          },
        };
      } else if (objType == 7) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              name: "",
            },
            {
              langCode: "zh_CN",
              name: "",
            },
            {
              langCode: "zh_HK",
              name: "",
            },
          ],
          highlights: [],
        };
      } else if (objType == 8) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              title: "",
              subTitle: "",
              image: "",
              content: "",
            },
            {
              langCode: "zh_CN",
              title: "",
              subTitle: "",
              image: "",
              content: "",
            },
            {
              langCode: "zh_HK",
              title: "",
              subTitle: "",
              image: "",
              content: "",
            },
          ],
        };
      } else if (objType == 9) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              name: "",
            },
            {
              langCode: "zh_CN",
              name: "",
            },
            {
              langCode: "zh_HK",
              name: "",
            },
          ],
          artists: [],
        };
      } else if (objType == 10) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              name: "",
              introduction: "",
              image: "",
            },
            {
              langCode: "zh_CN",
              name: "",
              introduction: "",
              image: "",
            },
            {
              langCode: "zh_HK",
              name: "",
              introduction: "",
              image: "",
            },
          ],
        };
      } else if (objType == 15) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              title: "",
            },
            {
              langCode: "zh_CN",
              title: "",
            },
            {
              langCode: "zh_HK",
              title: "",
            },
          ],
          records: [],
        };
      } else if (objType == 16) {
        var data = {
          scheduleDate: "",
          eventIds: [],
          eventList: [],
          events: [],
          langMap: [],
        };
      } else if (objType == 17) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              title: "",
            },
            {
              langCode: "zh_CN",
              title: "",
            },
            {
              langCode: "zh_HK",
              title: "",
            },
          ],
          eventTypes: "",
          startTime: "",
          endTime: "",
        };
      }

      this.$store.commit("setgroup", {
        obj: data,
        objType: objType,
        index: index,
        boolean: true,
        callback: function () {
          that.$store.commit("setgroup", { string: "", boolean: false });
          if (index == undefined) {
            obj.push(data);
          }
        },
      });
    },
  },
};
</script>
